import React, { useState, useEffect } from 'react';
import { TextField, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import FileBase from 'react-file-base64';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import useStyles from './styles';
import { createPost, updatePost } from '../../actions/posts';

const Form = ({ currentId, setCurrentId }) => {
  const [postData, setPostData] = useState({ creator: '', title: '', message: '', tags: '', selectedFile: '' });
  const post = useSelector((state) => (currentId ? state.posts.find((message) => message._id === currentId) : null));
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    if (post) setPostData(post);
  }, [post]);

  const clear = () => {
    setCurrentId(0);
    setPostData({ creator: '', title: '', message: '', tags: '', selectedFile: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (currentId === 0) {
      dispatch(createPost(postData));
      clear();
    } else {
      dispatch(updatePost(currentId, postData));
      clear();
    }
  };


  return (
    <Paper className={classes.paper}>
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
        
        <Typography font='Charm, cursive' color='secondary'>{currentId ? `Editing "${post.title}"` : <b>Memory Creator</b>}</Typography>
        
        <TextField name="creator" variant="outlined" label="Creator" fullWidth value={postData.creator} onChange={(e) => setPostData({ ...postData, creator: e.target.value })} />
        <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({ ...postData, title: e.target.value })} />
        <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({ ...postData, message: e.target.value })} />
        
        <Button
          variant="contained"
          color="secondary"  
          startIcon={<CloudUploadIcon />} 
          className={classes.fileInput}>
            <FileBase 
              type="file" multiple={false} 
              onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} 
            />
        </Button>
        <Button 
          className={classes.buttonSubmit} 
          variant="outlined" 
          color="secondary" 
          size="large" 
          type="submit" 
          fullWidth>
            <b>Submit</b>
        </Button>
        <Button 
          variant="contained" 
          size="small" 
          onClick={clear} fullWidth>
            <b>Clear</b>
        </Button>
        
      </form>
    </Paper>
  );
};

export default Form;
